import axios from "axios";

const clienteAxios = axios.create({
  //https://api.gas.ultra.neitor.com/
  baseURL: "https://api.gas.ultra.neitor.com/api/",
});

export const clienteZarazayApi = axios.create({
  baseURL: "http://186.101.181.90:9111/api/",
});
export const clientePts2Api = axios.create({
  baseURL: "https://pts2-gas-ultra.neitor.com",
});
export default clienteAxios;
